import Route from "@/scripts/routeRegistrar"
const RouteRegistrar = new Route('tender');

RouteRegistrar.add("tender/notices/Notices", "notices", "notices", "مناقضات/مزایدات");
RouteRegistrar.add("tender/notices/NoticeBids", "notices/:id/bids", "notice-bids", "پیشنهادات");
RouteRegistrar.add("tender/notices/ClosedNotices", "closed-notices", "closed-notices", "مناقضات/مزایدات پایان یافته");


const routes = RouteRegistrar.allRoutes()


export default routes;
